var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_81_515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 36,
    r: 36,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.793 41.9357C34.1469 38.1444 33.4942 34.3554 32.8662 30.5609C32.8093 30.22 32.833 29.8228 32.9504 29.5019C35.0792 23.7394 37.2268 17.9844 39.3744 12.2294C39.7539 11.2136 40.6967 10.6384 41.7635 10.7633C43.0072 10.9091 43.8954 11.6283 44.5373 12.6535C45.1548 13.6391 45.4991 14.6903 45.3824 15.9159C45.0203 19.7404 44.7402 23.5724 44.4126 27.4005C44.3761 27.8248 44.5365 27.8662 44.8791 27.8019C46.9022 27.424 48.9253 27.0389 50.9535 26.6909C52.6825 26.3939 54.3326 26.6504 55.8931 27.5014C58.6195 28.9898 59.8616 32.0945 58.648 34.9556C56.7943 39.3233 54.822 43.6402 52.8405 47.9516C52.2332 49.2727 51.4008 50.4959 50.141 51.2862C49.518 51.6766 48.8081 52.025 48.0954 52.1571C44.5271 52.8185 40.9432 53.395 37.3686 54.0195C36.9196 54.0984 36.8289 53.8959 36.7669 53.5251C36.1166 49.6611 35.4549 45.799 34.7966 41.9363L34.7921 41.9371L34.793 41.9357Z",
    fill: "url(#paint0_linear_81_515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8985 42.6894C31.503 46.2367 32.1073 49.7829 32.7118 53.3302C32.8923 54.3891 32.5895 54.8245 31.553 55.0011C29.5938 55.335 27.6346 55.6689 25.6752 56.0016C24.6692 56.1719 24.1886 55.825 24.0138 54.7995C22.8039 47.7204 21.5951 40.6411 20.3886 33.5614C20.2139 32.5359 20.5547 32.042 21.5534 31.8706C23.5407 31.5295 25.5282 31.1896 27.5164 30.8544C28.4289 30.6989 28.9205 31.0486 29.0763 31.9625C29.688 35.5382 30.2949 39.1135 30.9043 42.6896L30.8975 42.6908L30.8985 42.6894Z",
    fill: "url(#paint1_linear_81_515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_81_515",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_81_515"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_81_515",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_81_515",
    x1: 42.4309,
    y1: 10.5499,
    x2: 49.487,
    y2: 51.9544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004BBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_81_515",
    x1: 24.4952,
    y1: 31.367,
    x2: 28.6084,
    y2: 55.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004BBB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4,
    height: 42,
    fill: "white",
    transform: "translate(17.2002 14.8511) rotate(-9.6713)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.48f7460d004625d2c7833954c2f063e0.svg";
export { ForwardRef as ReactComponent };